import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export async function fetchMetalPrices() {
  const { data } = await api.get("/metals/prices");
  return data;
}

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export async function submitQuote(payload) {
  const { data } = await api.post("/quote", payload);
  return data;
}

export async function subscribeNewsletter(email) {
  const { data } = await api.post("/newsletter", { email });
  return data;
}

export async function requestCallback(payload) {
  const { data } = await api.post("/callback", payload);
  return data;
}
